import * as Sentry from '@sentry/react';

const isLocalhost = window.location.hostname === 'localhost'
  || window.location.hostname === '127.0.0.1'
  || window.location.hostname === '[::1]'; // IPv6 localhost
if (!isLocalhost) {
  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    release: process.env.REACT_APP_SENTRY_RELEASE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(), // Ta caro
    ],
    ignoreErrors: [
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'Java object is gone',
    ],
    beforeSend(event, hint) {
      const reason = hint?.originalException;
      if (typeof Event !== 'undefined' && reason instanceof Event) {
        return null;
      }
      return event;
    },
    // Performance Monitoring
    tracesSampleRate: 0.2, //  Capture 20% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/idoctor-dev.firebaseapp\.com/, /^https:\/\/meagenda\.com.br/],
    environment: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
